import { Injectable } from '@angular/core';
import { Store, guid } from '@datorama/akita';

export interface MfaEngageDialogState {
	readonly isSaving: boolean;
}

@Injectable()
export class MfaEngageDialogStore extends Store<MfaEngageDialogState> {
	constructor() {
		super({}, { name: `ui-mfa-engage-dialog-${guid()}` });
	}
}
